/**
 * Mobile toggle for the category row (snippets/vault-subnav.liquid).
 *
 * On phones the category list is hidden behind a "Shop by Category" button and
 * opens as a dropdown over the page. On desktop the button is hidden by CSS and
 * the list is always visible, so none of this has any effect there.
 */
(function () {
  var root = document.querySelector('.vault-subnav');
  if (!root) return;
  var toggle = root.querySelector('.vault-subnav__toggle');
  if (!toggle) return;

  function setOpen(open) {
    root.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setOpen(!root.classList.contains('is-open'));
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });
})();
